(function($) {
  Drupal.behaviors.ELB_sdFilterSetClickOutside = {
    attach: function() {
      if (this.attached) {
        return;
      }

      this.attached = true;

      var DEBOUNCE_DELAY = 150;
      var SAFETY_TIMEOUT = 2500;

      function closeAllFilterSets() {
        var $openButtons = $('.js-product-grid--filter-set.active');

        $openButtons.each(function() {
          $(this).trigger('click');
        });
      }

      if (typeof $.cookie === 'function' && $.cookie('LOCALE') === 'es_MX') {
        $(document).on('click.removeTouts', '.js-dropdown-option, select', function() {

            var $touts = $('.js-grid-item-tout');
            if ($touts.length === 0) return;

            $touts.addClass('elc-touts-hidden');

            var $targetElements = $('.js-product-tout-wrapper').length ?
                                  $('.js-product-tout-wrapper').slice(0, 3) :
                                  $touts.slice(0, 3);

            var debounceTimer;
            var observer = new MutationObserver(function(mutations) {
                clearTimeout(debounceTimer);

                debounceTimer = setTimeout(function() {
                    var $currentTouts = $('.js-grid-item-tout');

                    if ($(window).width() < 768) {
                        $currentTouts.each(function() {
                            var $tout = $(this);
                            if ($tout.prevAll('.js-grid-item-product').length === 0) {
                                $tout.remove();
                            }
                        });
                    } else {
                        if ($currentTouts.length > 4) {
                            $currentTouts.slice(0, 3).remove();
                        }
                    }

                    $('.js-grid-item-tout')
                        .removeClass('elc-touts-hidden')
                        .addClass('elc-touts-fade-in');

                    setTimeout(function() {
                        $('.js-grid-item-tout').addClass('is-visible');
                    }, 50);

                    observer.disconnect();
                }, DEBOUNCE_DELAY);
            });

            observer.observe(document.body, { childList: true, subtree: true });

            setTimeout(function() {
                $('.js-grid-item-tout').removeClass('elc-touts-hidden').addClass('is-visible');
                observer.disconnect();
            }, SAFETY_TIMEOUT);
        });
    }

      $(document).on('click.sdFilterSetClickOutside', function(event) {
        var target = event.target;
        var $target = $(target);
        var $openButtons = $('.js-product-grid--filter-set.active');
        var $closestWrapper = $target.closest('.js-product-grid--filter-set-wrapper');
        var $closestOptions = $target.closest('.js-product-grid--filter-options-wrapper');
        var isInsideFilter = $closestWrapper.length || $closestOptions.length;

        if (!target.isConnected || !$openButtons.length || isInsideFilter) {
          return;
        }

        closeAllFilterSets();
      });

      $(document).on('keyup.sdFilterSetClickOutside', function(e) {
        if (e.which === 27) {
          closeAllFilterSets();
        }
      });
    }
  };
})(jQuery);
